import { useQuery } from "@tanstack/react-query";
import { listOrganisations } from "../containers/newBackendApi/organisations";

// The session's org memberships + which one is active (GET /developer/organisations),
// the list the org switcher reads. Ported from the accounts app to keep the two
// switchers identical. Cached so it isn't re-hit on every navbar mount.
export const organisationKeys = {
  memberships: () => ["organisations", "memberships"],
};

export const useMemberships = (options = {}) =>
  useQuery({
    queryKey: organisationKeys.memberships(),
    queryFn: () => listOrganisations(),
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    ...options,
  });
